import React from "react";
import { Container, Typography, Divider, Box } from "@mui/material";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        background: "#0f172a",                // deep indigo background
        color: "rgba(255,255,255,0.85)",      // soft white text
      }}
    >
      <Divider sx={{ background: "rgba(255,255,255,0.15)" }} />
      <Container maxWidth="lg" sx={{ py: 4, textAlign: "center" }}>
        <Typography
          variant="body2"
          sx={{
            color: "rgba(255,255,255,0.7)",
            "& a": {
              color: "#4ade80",               // emerald link (if any added later)
              textDecoration: "none",
              "&:hover": { textDecoration: "underline" },
            },
          }}
        >
          © {new Date().getFullYear()} Pathway Technologies. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
